<!--
 * @Description: 
 * @Date: 2024-01-11 14:07:13
-->
<template>
  <div class="svg-block" :class="!isDetail && 'isDetail'" v-html="svg"></div>
</template>

<script setup lang="tsx">
import { ref, withDefaults, defineProps } from 'vue';

const props = withDefaults(
  defineProps<{ isDetail?: boolean; pageNo?: string }>(),
  {
    isDetail: false,
    pageNo: '01'
  }
);

const svg = ref(`
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 132.744 45">
    <g id="yema12" transform="translate(-80 -80)">
      <path id="路径_5241" data-name="路径 5241" d="M-13737.45-1791.394h-131.244v-34.688" transform="translate(13950.194 1913.394)" fill="none" stroke="var(--theme-color-1)" stroke-width="3"/>
      <text id="_01" data-name="01" transform="translate(90 114)" fill="var(--theme-color-1)" font-size="32" font-weight="600"><tspan x="0" y="0">${props.pageNo}</tspan></text>
    </g>
  </svg>
`);
</script>
<style lang="scss" scoped>
@import './index.scss';
.isDetail {
  position: absolute;
  bottom: 20px;
  right: 20px;
}
</style>
